export default [
	{
		path: '*',
		lazy: async () => {
			const Module = await import('../../pages/notFound/NotFoundPage');
			return { Component: Module.default };
		},
	},
];
